import moment from "moment";

// return the user data from the session storage
export const getUser = () => {
  const userStr = sessionStorage.getItem("user");
  if (userStr) return JSON.parse(userStr);
  else return null;
};

// return the token from the session storage
export const getToken = () => {
  return sessionStorage.getItem("token") || null;
};

// remove the token and user from the session storage
export const removeUserSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
};

// set the token and user from the session storage
export const setUserSession = (token, user) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("user", JSON.stringify(user));
};

export const setUserLanguage = (lang) => {
  localStorage.setItem("language", lang);
};

export const getUserLanguage = () => {
  return localStorage.getItem("language");
};

export const formatTimeStamp = (time) => {
  if (!isNaN(time)) {
    if (time < 1000000000 * 1000) {
      time = time * 1000;
    }
    return new Date(time).toISOString();
  } else if (time.includes(" ")) {
    time = time.replace(" ", "T");
    time = time + ".000Z";
    return time;
  }
  return time;
};

export const formatTimeWithTZOffset = (data) => {
  return moment(formatTimeStamp(data)).local().format("YYYY-MM-DD HH:mm:ss");
  /*
	return new Date(Date.parse(v) - new Date(data).getTimezoneOffset() * 60 * 1000)
	.toISOString()
	.substr(0, 19)
  .replace("T", " ");
  */
  //moment.unix(1399335987).format('YYYY-MM-DD HH:mm:ss')
  //	return v
};
export const getTimestampWithoutOffset = (data) => {
  return new Date(Date.parse(data.replace(" ", "T")))
    .toISOString()
    .replace("T", " ")
    .substr(0, 19);
};

export const validateDateType = (data, format) => {
  if (!data) {
    return false;
  } else {
    if (format === "date") {
      return data.match(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    } else {
      return data.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/);
    }
  }
};

/**
 * Takes temp as integer and checks if its valid
 * @param temp
 * @returns boolean
 */
export const checkValidTemperature = (temp) => {
  if (temp === null || isNaN(temp) || temp === -9999 || temp === 8500) {
    return false;
  }
  return true;
};

export const getAlertType = (type, t) => {
  switch (type) {
    case 0:
      return t("topbar.dailyNotification");
    case 1:
      return t("topbar.tempLow");
    case 2:
      return t("topbar.tempHigh");
    case 3:
      return t("topbar.doorOpen");
    default:
      break;
  }
};

export const formatChartData = (data) => {
  var retdata = [];
  data.forEach((element) => {
    retdata.push({
      tempOne: checkValidTemperature(element.tempOne)
        ? element.tempOne / 100.0
        : null,
      tempTwo: checkValidTemperature(element.tempTwo)
        ? element.tempTwo / 100.0
        : null,
      tempThree: checkValidTemperature(element.tempThree)
        ? element.tempThree / 100.0
        : null,
      tempFour: checkValidTemperature(element.tempFour)
        ? element.tempFour / 100.0
        : null,
      tempFive: checkValidTemperature(element.tempFive)
        ? element.tempFive / 100.0
        : null,
      tempSix: checkValidTemperature(element.tempSix)
        ? element.tempSix / 100.0
        : null,
      tempSeven: checkValidTemperature(element.tempSeven)
        ? element.tempSeven / 100.0
        : null,
      tempEight: checkValidTemperature(element.tempEight)
        ? element.tempEight / 100.0
        : null,
      tempNine: checkValidTemperature(element.tempNine)
        ? element.tempNine / 100.0
        : null,
      tempTen: checkValidTemperature(element.tempTen)
        ? element.tempTen / 100.0
        : null,
      tempEleven: checkValidTemperature(element.tempEleven)
        ? element.tempEleven / 100.0
        : null,
      tempTwelve: checkValidTemperature(element.tempTwelve)
        ? element.tempTwelve / 100.0
        : null,
      tempThirteen: checkValidTemperature(element.tempThirteen)
        ? element.tempThirteen / 100.0
        : null,
      tempFourteen: checkValidTemperature(element.tempFourteen)
        ? element.tempFourteen / 100.0
        : null,
      tempFifteen: checkValidTemperature(element.tempFifteen)
        ? element.tempFifteen / 100.0
        : null,
      timeStamp: formatTimeWithTZOffset(element.timeStamp),
    });
  });
  return retdata;
};

export const getIntegerFromSpelledNumber = (data) => {
  switch (data) {
    case "One":
      return 1;
    case "Two":
      return 2;
    case "Three":
      return 3;
    case "Four":
      return 4;
    case "Five":
      return 5;
    case "Six":
      return 6;
    case "Seven":
      return 7;
    case "Eight":
      return 8;
    case "Nine":
      return 9;
    case "Ten":
      return 10;
    case "Eleven":
      return 11;
    case "Twelve":
      return 12;
    case "Thirteen":
      return 13;
    case "Fourteen":
      return 14;
    case "Fifteen":
      return 15;
    default:
      break;
  }
};

export const numberToWord = (data) => {
  switch (data) {
    case 1:
      return "One";
    case 2:
      return "Two";
    case 3:
      return "Three";
    case 4:
      return "Four";
    case 5:
      return "Five";
    case 6:
      return "Six";
    case 7:
      return "Seven";
    case 8:
      return "Eight";
    case 9:
      return "Nine";
    case 10:
      return "Ten";
    case 11:
      return "Eleven";
    case 12:
      return "Twelve";
    case 13:
      return "Thirteen";
    case 14:
      return "Fourteen";
    case 15:
      return "Fifteen";
    default:
      break;
  }
};

export const hslToHex = (h, s, l) => {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
};
